import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IRotatedAuthTokensResponse } from 'api/components/Auth/types';
import { setAccessRefreshTokens } from 'api/utils/tokenManagement';

import { notifyError } from 'store/notifications/actions';
import { getUserFeatures } from 'store/user/actions';

import { UP_UTM_SOURCE } from 'constants/urlParams.ts';

import { Provider } from 'services/Analytics/core';

import { LS_KEYS } from 'helpers/localStorage.ts';
import { getQueryParamFromUrl } from 'helpers/urlParams.ts';

import { authenticateByCWTToken, setAuthenticationStatus, setAuthRedirectUrl } from '../actions';

import { getWFTokenForWebPlatform, waitForGetCurrentUser } from './helpers';

export function* authenticateByCWTTokenSaga({ payload }: ReturnType<typeof authenticateByCWTToken>) {
    const { onSuccess, onError, authToken } = payload;
    const utmSource = getQueryParamFromUrl(UP_UTM_SOURCE) || 'default_device';

    localStorage.setItem(LS_KEYS.UTM_SOURCE, utmSource);
    Provider.setUTMSource(utmSource);

    try {
        const { access, refresh }: IRotatedAuthTokensResponse = yield call(api.auth.getTokenByCWT, {
            token: authToken,
        });

        yield call(setAccessRefreshTokens, { access, refresh });

        yield call(waitForGetCurrentUser);

        yield call(getWFTokenForWebPlatform);

        yield put(setAuthenticationStatus(true));

        if (onSuccess) {
            yield call(onSuccess);
        }

        yield put(getUserFeatures());
        yield put(setAuthRedirectUrl(null));
    } catch (error: any) {
        yield put(notifyError({ message: 'message.error.somethingWentWrong' }));
        yield put(setAuthenticationStatus(false));

        if (onError) {
            yield call(onError, error);
        }
    }
}
